import {
    NodeChange,
    NodeSelectionChange,
    EdgeChange,
    applyNodeChanges,
    applyEdgeChanges,
    isNode,
    Node,
    Edge,
} from "reactflow";
import { AnyAction, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { setNodes, setEdges, selectElements, selectNodes, selectEdges, selectSelection } from "./JourneyStateSlice";

// function isConnectedEdge(element: { source?: string; target?: string }, nodeIds: string[]): boolean {
function isConnectedEdge(element: Node | Edge, nodeIds: string[]): boolean {
    if (isNode(element)) {
        return false;
    }
    return (
        (element.source != null && nodeIds.includes(element.source)) ||
        (element.target != null && nodeIds.includes(element.target))
    );
}

export function updateNodes(changes: NodeChange[]): ThunkAction<void, RootState, unknown, AnyAction> {
    return function thunk(dispatch: Dispatch<AnyAction>, getState: () => RootState): void {
        if (changes.length === 0) {
            return;
        }

        // changeType: "position" | "add" | "reset" | "select" | "dimensions" | "remove"
        const changeType = changes[0].type;
        if (changeType === "remove") {
            // nodes removal is handled in Flow by onNodesDelete callback
            return;
        }
        const nodes = selectNodes(getState());
        // apply changes to nodes
        dispatch(setNodes(applyNodeChanges(changes, nodes)));

        if (changeType === "select") {
            const selection = selectSelection(getState());

            const deselected = changes.filter(
                (change) => change.type === "select" && !change.selected
            ) as NodeSelectionChange[];
            if (deselected.length > 0 && selection && selection.length > 0) {
                const deselectedNodesIds = deselected.map((change) => change.id);
                const deselectedNodes = selection.filter(
                    (element) =>
                        !deselectedNodesIds.includes(element.id) &&
                        !isConnectedEdge(element as Node | Edge, deselectedNodesIds)
                );
                dispatch(selectElements(deselectedNodes.length > 0 ? deselectedNodes : null));
            }

            const selected = changes.filter(
                (change) => change.type === "select" && change.selected
            ) as NodeSelectionChange[];
            if (selected.length > 0) {
                const selectedNodesIds = selected.map((change) => change.id);
                const selectedNodes = nodes.filter((node) => selectedNodesIds.includes(node.id));
                const selection = selectSelection(getState());
                const newSelection = [...(selection || []), ...selectedNodes];
                dispatch(selectElements(newSelection));
            }
        }
    };
}

export function updateEdges(changes: EdgeChange[]): ThunkAction<void, RootState, unknown, AnyAction> {
    return function thunk(dispatch: Dispatch<AnyAction>, getState: () => RootState): void {
        const edges = selectEdges(getState());
        dispatch(setEdges(applyEdgeChanges(changes, edges)));
    };
}
